module.exports = __webpack_public_path__ + "static/img/banner.e6b0d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/Paint/banner.png
// module id = IpsF
// module chunks = 0